/**
 * Question class for QA
 */
import { BaseAPI } from '../BaseAPI'

class ConnectintClass extends BaseAPI {

  /**
   *  @method: getQuestionList method to list the question
   *  @params: primary question Id
   *  @output: data in object 
   */

  getQuestionList = (questionKey) => {
    let postBody = {"questionKey" : questionKey};
    return this.postData(`${this.baseURL}/connectint/v1/question/list`, postBody); 
    /* let questionList = {};
    if (questionKey === 'primary') {
      questionList = {
        data: {
          statusCode: 200,
          questions: [
            {
              key: "qset1-opt1",
              value: "【ドコモ光】初期設定を行いたい（ドコモから機器お届け後）(docomo Hikari) Initial Setting (After receiving device from docomo)"
            },
            {
              key: "qset2-opt1",
              value: "【ドコモ光】初期設定を行いたい（作業員によるご自宅での工事後）(docomo Hikari) Ini…stallation at your house done by technical staff)"
            },
            {
              key: "qset3-opt1",
              value: "パソコン・スマートフォンを追加で接続したいAddition of new PC or smartphone"
            }
          ]
        }
      }
    } else {
      questionList = {
        "qset1-opt1":
        {
          data: {
            "statusCode": 200,
            "question": "プロバイダよりユーザーID/パスワードは届いていますか？Have you received user/password from Provider?",
            "options": [
              {
                "key": "opt11",
                "value": "届いているYes I have"

              },
              {
                "key": "opt12",
                "value": "届いていないNo I have not",
                "articleID": "9990002"
              }
            ]
          }
        },
        "opt11":
        {
          data: {
            "statusCode": 200,
            "question": "ご利用のルーターをお選びくださいWhat is your router?",
            "options": [
              {
                "key": "opt111",
                "value": "レンタル】ルーター（無線LANカードなし）(Rental) Router (Without wireless LAN card",
                "articleID": "1003022"

              },
              {
                "key": "opt112",
                "value": "【レンタル】ルーター（無線LANカードあり）(Rental) Router (With wireless LAN card)",
                "articleID": "1002994"
              }
            ]

          }
        }

      }
    }
    return questionList;   */

  }

}

export { ConnectintClass }
